import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if current path is an admin page
    const isAdminPage = location.pathname.startsWith("/admin");

    // Only load Google Analytics and AdSense if not on admin pages
    if (!isAdminPage) {
      // Load Google Analytics (gtag)
      if (!window.gtag) {
        // Create and load the gtag script
        const gtagScript = document.createElement("script");
        gtagScript.async = true;
        gtagScript.src =
          "https://www.googletagmanager.com/gtag/js?id=AW-17646434028";
        document.head.appendChild(gtagScript);

        // Initialize gtag after script loads
        gtagScript.onload = () => {
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            window.dataLayer.push(arguments);
          }
          window.gtag = gtag;
          gtag("js", new Date());
          gtag("config", "AW-17646434028");
        };
      } else {
        // If gtag is already loaded, just send page view
        window.gtag("config", "AW-17646434028", {
          page_path: location.pathname,
        });
      }

      // AdSense script is now loaded globally in index.html
      // Initialize adsbygoogle array if needed
      if (!window.adsbygoogle) {
        window.adsbygoogle = [];
      }
    }
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;
